import {ref, computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useLogger, useAuth} from '#imports';
import type {ServiceLevelType} from '../openapi';
import {Configuration, ServiceLevelApi, ServiceLevelType as ServiceLevel} from '../openapi';

export function useServiceLevel() {
    const logger = useLogger();
    const {user, getSelectedIdentity} = storeToRefs(useAuth());

    const configuration = new Configuration({basePath: ''});
    const serviceLevelApiEndPoints = new ServiceLevelApi(configuration);

    const serviceLevel = ref<ServiceLevelType>();

    const serviceLevelType = computed(() => {
        if (serviceLevel.value === ServiceLevel.Standard) {
            return 'STARTER';
        }
        if (serviceLevel.value === ServiceLevel.Advanced) {
            return 'ADVANCED';
        }
        if (serviceLevel.value === ServiceLevel.Corporate) {
            return 'ENTERPRISE';
        }
        return '';
    });

    async function initServiceLevel() {
        if (serviceLevel.value) {
            return;
        }
        const organizationId = getSelectedIdentity.value?.organizationId;
        if (!organizationId) {
            return;
        }
        serviceLevel.value = (user.value?.extraInformation?.serviceLevel as ServiceLevelType) ?? (await getServiceLevelStatus(organizationId));
    }

    async function getServiceLevelStatus(organizationId: string): Promise<ServiceLevelType | undefined> {
        try {
            const serviceLevelStatus = await serviceLevelApiEndPoints.getStatusOnServiceLevelForOrganization(organizationId);

            return serviceLevelStatus?.currentServiceLevelType;
        } catch (e) {
            logger.error('Cannot get service level status');
        }
    }

    return {
        serviceLevel,
        serviceLevelType,
        initServiceLevel,
    };
}
